<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 16:17:39
 * @LastEditors: luckymiaow
-->

<script lang="ts" setup>
import { InputNumber as AInputNumber } from 'ant-design-vue';
import { useAttrs, useSlots } from 'vue';
import type { InputNumberBaseProps, InputNumberInjectConfig } from '../types';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';

const { getBindValue } = useForm<InputNumberInjectConfig & InputNumberBaseProps>({
  componentName: 'inputNumber',
  attrs: useAttrs(),
});

const { useExcludeSlots } = useSlot({ slots: useSlots() }, ['iconRender', 'default']);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly && readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot :name="readOnlySlot" :text="getBindValue.value"></slot
  ></span>
  <a-input-number v-else v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </a-input-number>
</template>
